import React from 'react';

function CheckoutNowButtonTemplate ({ modelAttributes }) {

	const { hasCheckoutValidationError } = modelAttributes;

	return (
		<button
			type="submit"
			className="checkoutErrorTooltip checkOutNow calloutBtn xxLarge"
			aria-disabled={hasCheckoutValidationError}
		>
			Check Out Now
		</button>
	);

}

export default CheckoutNowButtonTemplate;
